import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.FinancialDataProviderList })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.FinancialDataProviderEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.FinancialDataProviderCreate })));

export default { list, edit, create };
